/**
 * Created by Ivan on 10.08.2026
 */

const StickerView2 = function (sticker, options) {
    options = options || {};

    return Prefab.instantiate(bundles.sticker2.jsons.sticker_prefab_json, {
        sticker,
        withUpdate: options.withUpdate,
        badge: options.badge,
        rewardContext: options.rewardContext
    });
};
